import compose from 'utils/composeEnhancer'
import toggleAccordion from './toggleAccordion'

export default compose(toggleAccordion)
